import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0419adbb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title text-center" }
const _hoisted_2 = { class: "submit-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "myid"
}

import { reactive, computed, ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { FormItem } from '@/types/form';
  import { request } from '@/utils';
  import _ from 'lodash';

  type From = {
    phone_number?: string,
    verification_code: string,
    g_recaptcha_response?: string
  }

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t, locale } = useI18n();

  const defaultFrom = {
    phone_number: undefined,
    verification_code: '',
    g_recaptcha_response: ''
  };

  const phoneNumberDialCode = ref('');
  const myEmail = ref('');
  const form = reactive<From>(_.cloneDeep(defaultFrom));

  const formConfigs = computed<FormItem[]>(() => {
    return [
      {
        label: t('PHONE NUMBER FORM LABEL'),
        type: 'input',
        inputType: 'tel',
        key: 'phone_number',
        required: true,
        placeholder: '01012340000'
      },
       {
        label: t('CAPTCHA'),
        type: 'custom',
        required: true,
        placeholder: 'Captcha',
        key: 'g_recaptcha_response',
        inputType: 'text',
      },
      {
        label: t('VERIFICATION CODE'),
        type: 'input',
        key: 'verification_code',
        required: true,
        placeholder: ''
      },
    ];
  });

  function formItemChange(data: any) {
    form[data.key] = data.value;
  }

  function handleGetPhoneNumberCountry(country: any) {
    phoneNumberDialCode.value = country.dialCode;
  }

  function handleReset() {
    form.g_recaptcha_response = '';
  }

  async function handleSubmit() {
    const body: From = {
      verification_code: form.verification_code,
      phone_number: `+${phoneNumberDialCode.value} ${form.phone_number}`
    };
    const { data } = await request.post('/auth/get_email', body);
    myEmail.value = data.email;
    Object.assign(form, defaultFrom);
  }

return (_ctx: any,_cache: any) => {
  const _component_AppCountrySelector = _resolveComponent("AppCountrySelector")!
  const _component_GoogleRecaptcha = _resolveComponent("GoogleRecaptcha")!
  const _component_AppVerificationCodeBtn = _resolveComponent("AppVerificationCodeBtn")!
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('title')), 1),
    _createVNode(_component_b_form, {
      class: "form-box",
      onSubmit: handleSubmit
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formConfigs), (item) => {
          return (_openBlock(), _createBlock(_component_AppFormGroupItem, {
            key: item.key,
            form: _unref(form),
            config: item,
            onChange: formItemChange
          }, _createSlots({
            inputAfter: _withCtx(() => [
              (item.key === 'verification_code')
                ? (_openBlock(), _createBlock(_component_AppVerificationCodeBtn, {
                    key: 0,
                    target: `+${phoneNumberDialCode.value} ${_unref(form).phone_number}`,
                    captcha: _unref(form).g_recaptcha_response,
                    "target-type": "phone_number",
                    insert: "none",
                    event: "reset_password",
                    onReset: handleReset
                  }, null, 8, ["target", "captcha"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, [
            (item.key === 'phone_number')
              ? {
                  name: "inputBefore",
                  fn: _withCtx(() => [
                    _createVNode(_component_AppCountrySelector, {
                      "country-code": _unref(locale),
                      onExcountry: handleGetPhoneNumberCountry
                    }, null, 8, ["country-code"])
                  ])
                }
              : undefined,
            (item.key === 'g_recaptcha_response')
              ? {
                  name: "custom",
                  fn: _withCtx(() => [
                    _createVNode(_component_GoogleRecaptcha, {
                      modelValue: _unref(form)['g_recaptcha_response'],
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form)['g_recaptcha_response']) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                }
              : undefined
          ]), 1032, ["form", "config"]))
        }), 128)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_b_button, {
            pill: "",
            variant: "primary",
            size: "lg",
            type: "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('submit')), 1)
            ]),
            _: 1
          })
        ]),
        (myEmail.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)('my_id_is', { id: myEmail.value })), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})